import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useMessageService() {
    const { authenticatedFetch } = useApi();

    const enviarMensagem = async (dados) => {
        const response = await authenticatedFetch(URLS.SEND_CHART, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const enviarMensagemPdf = async (dados) => {
        const response = await authenticatedFetch(URLS.SEND_PDF, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    return {
        enviarMensagem,
        enviarMensagemPdf
    };
}